module.exports = __webpack_public_path__ + "static/media/aboutme.3824aa7b.svg";